import PlaylistsContent from './PlaylistsContent';
import PlaylistsProvider from 'contexts/playlists';
import { useCapabilities } from 'contexts/capabilities';
import EnterpriseUpsell, {
  ENTERPRISE_UPSELL_FEATURES,
  ENTERPRISE_UPSELL_METRICS,
  HighlightedText,
  PLAYLISTS_UPSELL_COPY,
} from 'components/enterpriseUpsell';
import styled from 'styled-components';

const PageContent = styled.div`
  position: relative;
  background: '#F2F2F7';
  height: 100%;
  display: flex;
  flex-direction: column;
`;
const Playlists = (): JSX.Element => {
  const { canUsePlaylists } = useCapabilities();

  if (!canUsePlaylists) {
    return (
      <PageContent>
        <EnterpriseUpsell
          eyebrow={PLAYLISTS_UPSELL_COPY.eyebrow}
          headline={
            <>
              Unlock <HighlightedText>{PLAYLISTS_UPSELL_COPY.headlineHighlight}</HighlightedText>{' '}
              with Enterprise
            </>
          }
          description={PLAYLISTS_UPSELL_COPY.description}
          features={ENTERPRISE_UPSELL_FEATURES}
          metrics={ENTERPRISE_UPSELL_METRICS}
        />
      </PageContent>
    );
  }

  return (
    <PlaylistsProvider>
      <PageContent>
        <PlaylistsContent />
      </PageContent>
    </PlaylistsProvider>
  );
};

export default Playlists;
